<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <img src="/img/avatars/default.png" class="img-avatar" alt="avatar" >
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>Account</strong></b-dropdown-header>
      <b-dropdown-item @click="handleLogout()"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { logout, handleError } from '@/services/metal'
import { store } from '@/shared/store'

export default {
  name: 'HeaderDropdownAccount',

  components: {
    AppHeaderDropdown
  },

  methods: {
    handleLogout() {
      if (!store.isProcessing()) {
        logout()
          .then(() => {
            localStorage.clear()
            this.$router.push('/login')
          })
          .catch(error => {
            handleError(error)
          })
      }
    },
  }, // methods
}
</script>
